import React from "react";

import { clsx } from "clsx";

import CheckIcon from "../../svgs/check.svg?react";

export default function Progress({ stage, progress }) {
	const stages = ["Hazard", "Vunerability", "Response", "Plan"];

	// Calculate overall progress percentage (0-100)
	const totalProgress = Math.min((stage - 1) * 33.333 + progress * 33.333, 100);

	return (
		<div
			role="progressbar"
			aria-labelledby="progress-label"
			aria-valuenow={Math.floor(totalProgress)}
			className="container-lg py-8 md:py-24"
			tabIndex={0}
		>
			<h2 id="progress-label" className="sr-only">
				Plan progress
			</h2>
			<div className="relative" aria-hidden="true">
				{/* bg bar */}
				<div className="absolute bottom-0 left-0 w-full h-5 md:h-8 bg-green-mid rounded-full overflow-hidden">
					{/* progress */}
					<div
						className="h-full bg-green-neon transition-[width] duration-500 ease-out"
						style={{ width: `${totalProgress}%` }}
					/>
				</div>
				{/* stage indicators */}
				<div className="w-full flex justify-between relative z-10">
					{stages.map((stageItem, index) => {
						const indexDisplay = index + 1;
						return (
							<div key={indexDisplay} className="w-min flex flex-col gap-3">
								<div
									className={clsx(
										"max-md:hidden w-8 flex justify-center whitespace-nowrap leader-uppercase uppercase",
										{
											"justify-start": index === 0,
											"justify-end": stages.length === index + 1,
										},
									)}
								>
									<span>{stageItem}</span>
								</div>
								<div className="size-5 font-semibold md:size-8 tabular-nums bg-black text-[12px] text-white rounded-full flex items-center justify-center md:text-base leading-none *:block">
									{indexDisplay >= stage ? (
										<span>{indexDisplay}</span>
									) : (
										<CheckIcon
											aria-hidden="true"
											className="size-3 md:size-4"
										/>
									)}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
